// Laedt den Popover-Polyfill nur, wenn der Browser die Popover-API nicht kennt.
//
// Warum: popover-polyfill.js prueft sich zwar selbst (letzte Zeile:
// `if (!isSupported()) apply();`) und tut auf modernen Browsern nichts — es wurde
// aber trotzdem auf jeder Seite heruntergeladen (5,5 KB gzip).
//
// Warum nicht ersatzlos entfernen: Popover traegt im Theme drei Dinge —
// den Warenkorb-Tooltip, die Mengenstaffel-Info und die RECHTSLINKS IM FOOTER.
// Auf Browsern ohne native Unterstuetzung (Safari < 17, Chrome < 114,
// Firefox < 125) waeren die Rechtslinks sonst nicht erreichbar. Das waere
// ein rechtliches Problem, kein kosmetisches.
//
// Die Pruefung entspricht der des Polyfills selbst.
if (
  typeof HTMLElement === 'undefined' ||
  typeof HTMLElement.prototype.showPopover !== 'function'
) {
  import('@theme/popover-polyfill');
}
